import { useEffect, useState } from "react";
import { useStableCallback } from "./useStableCallback";
import { useDebounceCallback } from "usehooks-ts";
import { useCustomEventListener } from "./useCustomEventListener";
import { useDispatch } from "react-redux";
import { syncUiScrollAction } from "../../actions";
// TODO: add UI tree path and sync ui event
export const useScrollProps = (_path, size, maxItems, { initialScroll = 0, scrollDelta = 1, infiniteScroll = false } = {}) => {
    const dispatch = useDispatch();
    const [scroll, setScroll] = useState(initialScroll);
    useEffect(() => {
        if (!infiniteScroll && scroll > size - maxItems) {
            setScroll(0);
        }
    }, [infiniteScroll, maxItems, scroll, size]);
    const maxScroll = Math.max(0, size - maxItems);
    const scrollUp = useStableCallback(() => setScroll((prev) => (infiniteScroll ? prev - scrollDelta : Math.max(prev - scrollDelta, 0))));
    const scrollDown = useStableCallback(() => setScroll((prev) => (infiniteScroll ? prev + scrollDelta : Math.min(prev + scrollDelta, maxScroll))));
    const debouncedScrollWheel = useDebounceCallback((e) => {
        if (e.deltaY > 0 && (infiniteScroll || scroll < maxScroll)) {
            scrollDown();
        }
        else if (e.deltaY < 0 && (infiniteScroll || scroll > 0)) {
            scrollUp();
        }
    }, 10);
    const path = `scroll/${_path}`;
    useEffect(() => {
        dispatch(syncUiScrollAction({ path, scroll }));
    }, [scroll]);
    useCustomEventListener("ui:sync:scroll", (event) => {
        const { path: eventPath, scroll } = event.detail;
        if (path === eventPath) {
            setScroll(scroll);
        }
    });
    const scrollWheel = useStableCallback(debouncedScrollWheel);
    return {
        scrollUp,
        scrollDown,
        scrollWheel,
        scroll,
        scrollUpDisabled: !infiniteScroll && scroll === 0,
        scrollDownDisabled: !infiniteScroll && scroll === maxScroll,
    };
};
//# sourceMappingURL=useScrollProps.js.map